
import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import ProjectMixin from '@/_mixins/project'
import Container from '@/components/Placeholders/Container/Container.vue'
import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'
import { setObservationFilter } from '@/types/observation'

@Component({
    mixins: [ObservationMixin, ProjectMixin],
    components: { Container },
})
export default class ObservationsIndex extends Mixins<MixinInterface>(
    ObservationMixin,
    ProjectMixin
) {
    accessible = false
    ready = false
    observationUrl = process.env.VUE_APP_OBSERVATIONS_BASE_URL
    projectUrl = process.env.VUE_APP_PROJECT_BASE_URL

    // Projects
    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get projects() {
        let projects: Array<any> = []
        this.group
            ? Object.values(this.$store.getters.projectModules).map((item: any) => {
                  item.relationships.module.data.id == 'observation'
                      ? projects.push(item.relationships.project.data.id)
                      : null
              })
            : (projects = [this.project.id])
        return projects
    }

    async getObservationTemplate() {
        const { data } = await getRequest(
            this.getURL({
                path: `observations`,
                base: this.observationUrl,
                params: {
                    include: this.obsIncludes,
                    skipLinks: '',
                    ...(this.group && { 'filter[templateForProjectGroup]': this.group.id }),
                    ...(this.project && { 'filter[templateForProject]': this.project.id }),
                },
            })
        )

        const observationTemplates = deserialise(data).data
        this.$store.commit('observationTemplates', observationTemplates)
    }

    async getObservationCategories() {
        const { data } = await getRequest(
            this.getURL({
                path: `categories`,
                base: this.observationUrl,
                params: {
                    include:
                        'project,parent&fields[category]=index,name,isActive,parent,project&fields[project]=name&fields[parent]=name',
                    skipLinks: '',
                    ...(this.group && { 'filter[projectGroup]': this.group.id }),
                    ...(this.project && { 'filter[project]': this.project.id }),
                },
            })
        )

        let categories = deserialise(data).data
        categories = categories.map((category) => {
            if (category?.parent?.data) {
                category.parent.data = {
                    id: category.parent.data.id,
                    type: category.parent.data.type,
                }
            } else {
                category['parent']['data'] = null
            }
            return category
        })
        this.$store.commit('observationCategories', categories)
    }

    async getObservationCauses() {
        const { data } = await getRequest(
            this.getURL({
                path: `causes`,
                base: this.observationUrl,
                params: {
                    include:
                        'project,parent&fields[cause]=index,name,isActive,parent,project&fields[project]=name&fields[parent]=name',
                    skipLinks: '',
                    ...(this.group && { 'filter[projectGroup]': this.group.id }),
                    ...(this.project && { 'filter[project]': this.project.id }),
                },
            })
        )

        let causes = deserialise(data).data
        causes = causes.map((cause) => {
            if (cause?.parent?.data) {
                cause.parent.data = {
                    id: cause.parent.data.id,
                    type: cause.parent.data.type,
                }
            } else {
                cause['parent']['data'] = null
            }
            return cause
        })
        this.$store.commit('observationCauses', causes)
    }

    async getObservationLocations() {
        const { data } = await getRequest(
            this.getURL({
                path: `locations`,
                base: this.projectUrl,
                params: {
                    include:
                        'project,parent&fields[location]=index,name,isActive,parent,project&fields[project]=name&fields[parent]=name',
                    skipLinks: '',
                    ...(this.group && { 'filter[projectGroup]': this.group.id }),
                    ...(this.project && { 'filter[project]': this.project.id }),
                },
            })
        )

        let locations = deserialise(data).data
        locations = locations.map((location) => {
            if (location?.parent?.data) {
                location.parent.data = {
                    id: location.parent.data.id,
                    type: location.parent.data.type,
                }
            } else {
                location['parent']['data'] = null
            }
            return location
        })
        this.$store.commit('projectLocations', locations)
    }

    async mounted() {
        this.accessible = this.isModuleViewAccessible('observation.')

        if (this.accessible && this.isAuthenticated) {
            this.project
                ? await this.getObservationProject(this.project.id).catch(() => {
                      //
                  })
                : await this.getObservationProjects({
                      'filter[projectGroup]': this.group.id,
                  }).catch(() => {
                      //
                  })

            const localObservationParams = this.$store.getters.customFilters

            if (localObservationParams) {
                if (this.project) {
                    delete localObservationParams.project
                }

                this.$store.commit(
                    'observationFilter',
                    setObservationFilter(localObservationParams)
                )
                this.$store.commit('meMode', false)
                this.$store.commit('customFilters', null)
            }
        }

        this.ready = true

        if (this.accessible) {
            await Promise.all([
                this.getObservationCategories(),
                this.getObservationCauses(),
                this.getObservationLocations(),
                await this.getObservationTemplate(),
            ])
        }
    }

    beforeDestroy() {
        this.$store.commit('closeSnackbar')
        this.$store.commit('resetObservation')
        this.$store.commit('resetComment')
    }
}
